<div class="page-section">
    <div class="page-title-section">
        <div class="text-section">
            <span>
                Credit Sales Record
            </span>
        </div>
        <div class="filter-section">
            <div class="main-filter-text-section">
                <span>
                    search:
                </span>
            </div>
            <div class="left-filter-section" (click)="frompicker.open()">
                <div class="filter-text-section">
                    <span>
                        From
                    </span>
                </div>
                <div class="control-section">
                    <mat-form-field appearance="none">
                        <input matInput [matDatepicker]="frompicker" name="frompicker" [(ngModel)]="selectedFromDate"
                        (dateChange)="dateChangeFnc($event, 'from')" >
                        <mat-datepicker #frompicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="icon-section">
                    <fa-icon icon="calendar-alt"></fa-icon>
                </div>
            </div>
            <div class="right-filter-section" (click)="topicker.open()">
                <div class="filter-text-section">
                    <span>
                        To
                    </span>
                </div>
                <div class="control-section">
                    <mat-form-field appearance="none">
                        <input matInput [matDatepicker]="topicker" name="topicker" [(ngModel)]="selectedToDate"
                        (dateChange)="dateChangeFnc($event, 'to')" >
                        <mat-datepicker #topicker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="icon-section">
                    <fa-icon icon="calendar-alt"></fa-icon>
                </div>
            </div>
        </div>
        <div class="btn-section">
            <div class="search-section">
                <div class="search-holder">
                    <div class="icon-section">
                        <fa-icon icon="search" matPrefix></fa-icon>
                    </div>
                    <div class="left-search-section">
                        <mat-form-field appearance="none" class="searchId">
                            <input matInput type="text" name="searchData" autocomplete="off" [(ngModel)]="searchData" 
                            placeholder="Filter current record"  />
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="page-holder">
        <div class="right-section" [@animateArc]="shoppingCartView">
            <div class="details-list-section" *ngIf="shoppingCartView == 'true'">
                <div class="top-details-section">
                    <div class="left-top-details-section">
                        <span>
                            Sales details
                        </span>
                    </div>
                    <div class="right-top-details-section">
                        <div class="icon-section" (click)="toggleCartView()">
                            <fa-icon icon="long-arrow-alt-right"></fa-icon>
                        </div>
                    </div>
                </div>
                <div class="down-details-section" [ngbPopover]="popContent"
                triggers="manual" popoverClass='popoversection' #popOver="ngbPopover">
                    <div class="item-list-section">
                        <div class="item-section" *ngFor="let x of selectedRecord.products">
                            <div class="item-details-section">
                                <div class="label-section">
                                    <span>
                                        Product
                                    </span>
                                </div>
                                <div class="value-section">
                                    <span>
                                        {{x.productName}}
                                    </span>
                                </div>
                            </div>
                            <div class="item-details-section">
                                <div class="label-section">
                                    <span>
                                        Measurement
                                    </span>
                                </div>
                                <div class="value-section">
                                    <span>
                                        {{x.unitOfMeasurement}}
                                    </span>
                                </div>
                            </div>
                            <div class="item-details-section">
                                <div class="label-section">
                                    <span>
                                        Selling Price
                                    </span>
                                </div>
                                <div class="value-section">
                                    <span>
                                        &#8358; {{x.sellingPrice | number:'.2'}}
                                    </span>
                                </div>
                            </div>
                            <div class="item-details-section">
                                <div class="label-section">
                                    <span>
                                        quantity
                                    </span>
                                </div>
                                <div class="value-section">
                                    <span>
                                        {{x.quantity | number}}
                                    </span>
                                </div>
                            </div>
                            <div class="item-details-section">
                                <div class="label-section">
                                    <span>
                                        Total
                                    </span>
                                </div>
                                <div class="value-section">
                                    <span>
                                        &#8358; {{x.totalAmount | number:'.2'}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item-details-section">
                        <div class="label-section">
                            <span>
                                Total amount
                            </span>
                        </div>
                        <div class="value-section">
                            <span>
                                &#8358; {{selectedRecord.totalAmount | number:'.2'}}
                            </span>
                        </div>
                    </div>
                    <div class="item-details-section">
                        <div class="label-section">
                            <span>
                                Remaining amount
                            </span>
                        </div>
                        <div class="value-section">
                            <span>
                                <b *ngIf="selectedRecord.remainingAmount">
                                    &#8358; {{selectedRecord.remainingAmount | number:'.2'}}
                                </b>
                                <b *ngIf="!selectedRecord.remainingAmount">
                                    &#8358; {{0 | number:'.2'}}
                                </b>
                            </span>
                        </div>
                    </div>
                    <div class="big-item-details-section">
                        <div class="label-section">
                            <span>
                                Expected Date of Payment
                            </span>
                        </div>
                        <div class="value-section">
                            <span>
                                {{selectedRecord.expectedDate | date : 'hh:mm:ss a dd MMM, yyyy': "UTC"}}
                            </span>
                        </div>
                    </div>
                    <div class="big-item-details-section">
                        <div class="label-section">
                            <span>
                                Staff
                            </span>
                        </div>
                        <div class="value-section">
                            <span>
                                {{selectedRecord.staff.name}}
                            </span>
                        </div>
                    </div>
                    <div class="big-item-details-section">
                        <div class="label-section">
                            <span>
                                Customer
                            </span>
                        </div>
                        <div class="value-section">
                            <span *ngIf="selectedRecord.customer">
                                {{selectedRecord.customer.personalInfo.fullName}}
                            </span>
                        </div>
                    </div>
                    <div class="item-details-section">
                        <div class="label-section">
                            <span>
                                Date Sold
                            </span>
                        </div>
                        <div class="value-section">
                            <span>
                                {{selectedRecord.createdAt | date : 'hh:mm:ss a dd MMM, yyyy': "UTC"}}
                            </span>
                        </div>
                    </div><div class="item-list-section">
                        <div class="item-details-section">
                            <div class="label-section">
                                <span>
                                    Payment History
                                </span>
                            </div>
                            <div class="value-section">
                            </div>
                        </div>
                        <div class="item-section" *ngFor="let x of history">
                            <div class="item-details-section">
                                <div class="label-section">
                                    <span>
                                        Amount Paid
                                    </span>
                                </div>
                                <div class="value-section">
                                    <span>
                                        &#8358;{{x.amount | number: '.2'}}
                                    </span>
                                </div>
                            </div>
                            <div class="big-item-details-section">
                                <div class="label-section">
                                    <span>
                                        Date Paid
                                    </span>
                                </div>
                                <div class="value-section">
                                    <span>
                                        {{x.Date | date : 'hh:mm:ss a dd MMM, yyyy': "UTC"}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="btn-details-section" *ngIf="selectedRecord.active">
                        <div class="full-btn-details-section">
                            <button mat-flat-button (click)="togglePopover(popOver)">
                                Pay Debt
                                
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="left-section" [@animateOtherArc]="marketView">
            <div class="data-section" *ngIf="records.length > 0">
                <div class="list-section">
                    <div class="list-item-section" *ngFor="let x of records|filter:searchData; let i = index" 
                    [class.newListItemSection]="marketView == 'true'" (click)="selectRecord(x)"
                    [class.activeRecord]="x._id == selectedRecord._id">
                        <div class="list-item-content" >
                            <div class="details-section">
                                <div class="top-details-section">
                                    <span>
                                        &#8358;{{x.totalAmount | number: '.2'}}
                                    </span>
                                </div>
                                <div class="middle-details-section">
                                    <span>
                                        <b *ngFor="let y of x.productDetails;">
                                            {{y.productName}}, 
                                        </b>
                                    </span>
                                </div>
                                <div class="down-details-section">
                                    <span>
                                        {{x.createdAt | date : 'hh:mm:ss a dd/MMM/yyyy ': "UTC"}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pagination-section">
                    <div class="pagination-text" (click)="getPage(1)">
                        <span>
                            First
                        </span>
                    </div>
                    <div class="pagination-text" (click)="paginate(-1)">
                        <span>
                            Prev
                        </span>
                    </div>
                    <div class="pagination-text" [class.activePage]="pageIndex == x"
                    *ngFor="let x of pageArray; let i = index" (click)="getPage(x)">
                        <span>
                            {{x}}
                        </span>
                    </div>
                    <div class="pagination-text" (click)="paginate(1)">
                        <span>
                            Next
                        </span>
                    </div>
                    <div class="pagination-text" (click)="getPage(noOfPages)">
                        <span>
                            Last
                        </span>
                    </div>
                    <div class="pagination-text" (click)="clearFilter()" *ngIf="dateFilterShow">
                        <span>
                            Clear
                        </span>
                    </div>
                </div>
            </div>
            <div class="no-data-section"  *ngIf="records.length <= 0">
                <div class="img-section">
                    <fa-icon icon="database"></fa-icon>
                </div>
                <div class="text-section">
                    <span>
                        No record Found
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #popContent>
    <div class="popover-content">
        <div class="top-popover-section">
            <span>
                Pay Off Debt
            </span>
        </div>
        <div class="down-popover-section">
            <form name="payForm" (ngSubmit)="payForm.form.valid && payDebt(payForm)"
            #payForm="ngForm" class="popoevr-form">
                <div class="product-list-section">
                    <div class="label-section">
                        <span>
                            Remaining Amount 
                        </span>
                    </div>
                    <div class="value-section">
                        <span>
                            &#8358; {{initialPayDetails.remainingAmount | number:'.2'}}
                        </span>
                    </div>
                </div>
                <div class="product-list-section">
                    <div class="label-section">
                        <span>
                            Amount to be paid
                        </span>
                    </div>
                    <div class="value-section">
                        <span>
                            &#8358; {{initialPayDetails.amount | number:'.2'}}
                        </span>
                    </div>
                </div>
                <div class="big-form-control-section">
                    <div class="label-section">
                        <span>
                            Amount
                        </span>
                    </div>
                    <div class="control-section">
                        <mat-form-field appearance="none">
                            <input matInput type="number" name="amount" 
                            [(ngModel)]="initialPayDetails.amount" #amount="ngModel" required/>
                            <mat-error *ngIf="payForm.submitted && amount.invalid">
                                Please enter a valid amount
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="popover-btn-section">
                    <button mat-flat-button>
                        Pay
                        <fa-icon icon="angle-right"></fa-icon>
                    </button>
                </div>
            </form>
        </div>
    </div>
</ng-template>